/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface RouteValidationData
 */
export interface RouteValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof RouteValidationData
     */
    departureIATA?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof RouteValidationData
     */
    arrivalIATA?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof RouteValidationData
     */
    departureDate?: ValidationMessage;
    /**
     * 
     * @type {number}
     * @memberof RouteValidationData
     */
    readonly index?: number;
}

export function RouteValidationDataFromJSON(json: any): RouteValidationData {
    return RouteValidationDataFromJSONTyped(json, false);
}

export function RouteValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RouteValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'departureIATA': !exists(json, 'departureIATA') ? undefined : ValidationMessageFromJSON(json['departureIATA']),
        'arrivalIATA': !exists(json, 'arrivalIATA') ? undefined : ValidationMessageFromJSON(json['arrivalIATA']),
        'departureDate': !exists(json, 'departureDate') ? undefined : ValidationMessageFromJSON(json['departureDate']),
        'index': !exists(json, 'index') ? undefined : json['index'],
    };
}

export function RouteValidationDataToJSON(value?: RouteValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'departureIATA': ValidationMessageToJSON(value.departureIATA),
        'arrivalIATA': ValidationMessageToJSON(value.arrivalIATA),
        'departureDate': ValidationMessageToJSON(value.departureDate),
    };
}


